import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5 1.497h15s3 0 3 3v15s0 3-3 3h-15s-3 0-3-3v-15s0-3 3-3m13.5 9h-4.5"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 10.497h3l3 4.5h6"
    }, null, -1)
  ]));
}
const computerKeyboardOption = { render };
export {
  computerKeyboardOption as default,
  render
};
//# sourceMappingURL=computer-keyboard-option.svg.js.map
